import { relativeDef } from "@skbkontur/staff-common";

export enum EmployeeRelativesActionType {
    CompleteLoading = "EmployeeRelativesAction.CompleteLoading",
    InsertAddedRelative = "EmployeeRelativesAction.InsertAddedRelative",
    SelectRelative = "EmployeeRelativesAction.SelectRelative",
}

export type EmployeeRelativesAction =
    | {
          type: EmployeeRelativesActionType.CompleteLoading;
          payload: {
              path: string;
              relatives: relativeDef[];
          };
      }
    | {
          type: EmployeeRelativesActionType.SelectRelative;
          payload: {
              path: string;
              relative: relativeDef | null;
          };
      }
    | {
          type: EmployeeRelativesActionType.InsertAddedRelative;
          payload: {
              path: string;
              relative: relativeDef;
          };
      };
